import { TextButton } from '@/shared/ui'

type Props = {
  name: string
  value: string | null
  onEditButtonClick: () => void
  isEditable?: boolean
}

export const FormPreview = ({
  name,
  value,
  onEditButtonClick,
  isEditable = true,
}: Props) => {
  if (!value && isEditable) {
    return (
      <TextButton
        type="button"
        color="purple"
        underline
        size="large"
        onClick={onEditButtonClick}
      >
        {name}를 입력해 주세요
      </TextButton>
    )
  }

  if (!value && !isEditable) {
    return <p className="typo-label1 font-medium text-gray-900">{name} 없음</p>
  }

  return (
    <div className="flex justify-between">
      <p className="typo-label1 font-medium text-gray-900">{value}</p>
      {isEditable && (
        <TextButton
          type="button"
          color="purple"
          underline
          size="large"
          onClick={onEditButtonClick}
        >
          수정하기
        </TextButton>
      )}
    </div>
  )
}
